import Swiper from 'swiper';
import {Pagination, Autoplay, A11y, EffectFade} from "swiper/modules"
import {SwiperOptions} from "swiper/types";

const colorSchemaClassNames = ['pampas', 'main', 'black'];

function changeBulletColor(swiper: Swiper) {
  // change color of bullets by setting CSS class from the current image text
  let colorSchemaClassName =
    swiper.wrapperEl.querySelector('.swiper-slide-active')?.querySelector(`:scope ${'.image-with-text__text'}`)?.getAttribute('class')
    || ""
  const imageSlider = swiper.el.parentElement;
  colorSchemaClassNames.forEach(className => {
    imageSlider?.classList.remove(className);
    if (colorSchemaClassName.includes(className)) colorSchemaClassName = className;
  })
  if (colorSchemaClassName) imageSlider?.classList?.add(colorSchemaClassName);
}

function InitImageSlider() {
  const sliderSettingsDefault: SwiperOptions = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    autoplay: {
      delay: 5000,
    },
    modules: [Pagination, Autoplay],
    loop: true,
  }

  const sliderSettingsLocation: SwiperOptions = {
    modules: [Pagination, Autoplay, A11y, EffectFade],
    pagination: {
      el: '.swiper-pagination--location',
      clickable: true,
      type: 'bullets',
    },
    autoplay: {
      delay: 3000,
    },
    effect: 'fade',
    speed: 1000,
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    slidesPerView: 1,
  }

  document.querySelectorAll('.image-slider').forEach((swiper) => {
    const isLocationSlider = !!swiper.querySelector('.swiper-pagination--location')
    const sliderSetting = isLocationSlider ? sliderSettingsLocation : sliderSettingsDefault

    let heroSlider = new Swiper(swiper.querySelector('.swiper-imageslider') as HTMLElement, sliderSetting)
    heroSlider.init()

    heroSlider.on('init', function (swiper) {
      changeBulletColor(swiper);
    });
    heroSlider.on('transitionEnd', function (swiper) {
      changeBulletColor(swiper);
    });
  })
}

InitImageSlider()
